import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StreakService } from '../services/StreakService';
import { XpService, DEFAULT_GOAL } from '../services/XpService';

export default function StreakXpBar() {
  const { t } = useTranslation();
  const [streak, setStreak]   = useState(0);
  const [todayXp, setTodayXp] = useState(0);
  const [goal, setGoal]       = useState(DEFAULT_GOAL);

  useEffect(() => {
    setStreak(StreakService.getStreak());
    setTodayXp(XpService.getTodayXp());
    setGoal(XpService.getGoal());
  }, []);

  const progress  = goal === 0 ? 0 : Math.min(1, todayXp / goal);
  const goalDone  = todayXp >= goal;

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mb-8">
      <div className="flex items-center gap-5 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
        {/* streak */}
        <div className="flex flex-col items-center min-w-[52px]">
          <span className="text-2xl leading-none">{streak > 0 ? '🔥' : '💤'}</span>
          <span className="mt-0.5 text-xl font-black text-slate-900 leading-none">{streak}</span>
          <span className="text-[10px] font-bold uppercase tracking-wide text-slate-400">{t('streakBar.streak')}</span>
        </div>

        <div className="h-10 w-px bg-slate-200 shrink-0" />

        {/* xp goal */}
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-center mb-1.5 text-xs font-bold">
            <span className="text-slate-500">{t('streakBar.dailyGoal')}</span>
            <span className={goalDone ? 'text-emerald-600' : 'text-indigo-600'}>
              {goalDone ? t('streakBar.done') : `${todayXp} / ${goal} XP`}
            </span>
          </div>
          <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{
                width: `${progress * 100}%`,
                background: goalDone
                  ? '#10B981'
                  : 'linear-gradient(to right, #6366F1, #7C3AED)',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
